import { imgSrcForUnicodeEmoji } from 'lib/emoji';
import cx from 'classnames';
import Image from 'components/Image';
import * as React from 'react';

import './styles/Emoji.scss';

/**
 * ## Emoji characters via [Twemoji](http://twitter.github.io/twemoji/).
 *
 *
 * # Implementation
 *
 * Rarely used directly. For cross-platform support, use
 * [TextWithEntities](/internal/components/TextWithEntities) or [TextEntities](/internal/components/TextEntities) to
 * parse & convert emoji.
 *
 *
 * ```example
 * <div>
 *   <Emoji character="\ud83c\udfc3" />
 *   <Emoji character="\ud83d\udca8 " />
 *   <Emoji character="\ud83d\ude93" />
 *   <Emoji character="\ud83d\ude93" />
 *   <Emoji character="\ud83d\ude93" />
 * </div>
 * ```
 */

const Emoji = ({ character, className }: { character: string; className?: string }) => (
  <Image
    alt={character}
    disableUserInteraction
    src={imgSrcForUnicodeEmoji(character)}
    className={cx('Emoji', className)}
  />
);

export default Emoji;
